export const AvailabilityAll = '0-1';
export const AvailabilityMax = '0-0.49';
export const AvailabilityMid = '0.5-0.89';
export const AvailabilityMin = '0.9-1';

export const initialViewSettings = {
    defaultView: 'resourceTimelineSlidingMonth',
    showAvailable: true,
    showSold: false,
    showInventory: true,
    showSoldAddons: false,
    showGrossInventoryDiff: false,
    showAvailabilityRatioFrom: 0,
    showAvailabilityRatioTo: 1,
    selectedAvailabilityView: AvailabilityAll,
};